import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { state as t } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { focusAndOpenKeyboard } from '../../utilities/behavior-helpers/index.js';
import '../../utilities/dom-helpers/index.js';
import css_248z from './awc-search-products.scss.js';

const isSearchOnScreen = () => {
    const windowBootmEdge = window.scrollY + window.innerHeight;
    const search = document.querySelector('awc-search-products search-form');
    const searchPosition = search.offsetHeight + search.getBoundingClientRect().top;
    return windowBootmEdge > searchPosition;
};
class AwcSearchProducts extends s {
    constructor() {
        super(...arguments);
        this.isFocused = false;
    }
    onRender() {
        if (this.isFocused)
            return;
        window.addEventListener('load', () => {
            var _a;
            if (!isSearchOnScreen()) {
                const selectedLink = document.querySelector('.link-button.selected');
                const topHeight = ((_a = document.querySelector('.container > .top')) === null || _a === void 0 ? void 0 : _a.offsetHeight) || 0;
                if (selectedLink) {
                    window.scrollTo(0, selectedLink.getBoundingClientRect().top - topHeight);
                }
            }
            const formSlot = this.querySelector('search-form');
            const input = formSlot.shadowRoot.querySelector('.search-input');
            focusAndOpenKeyboard(input, 300);
            this.isFocused = true;
        });
    }
    render() {
        this.onRender();
        return x `<slot name="form"></slot><slot name="results-title"></slot><slot name="results"></slot>`;
    }
}
AwcSearchProducts.styles = css_248z;
__decorate([
    t()
], AwcSearchProducts.prototype, "isFocused", void 0);
customElements.define('awc-search-products', AwcSearchProducts);

export { AwcSearchProducts };
